/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { APP_ROUTES } from './app/app.routes';
import { HotkeyModule } from 'angular2-hotkeys';
import { provideStore } from '@ngrx/store';
import { provideServiceWorker } from '@angular/service-worker';
import { CommandCentralHeaderComponentsModule, HeaderConfigService } from '@msi/commandcentral-common-header';
import { EnvironmentService } from './app/core/services/environment.service';
import { KeycloakOidcProviderService } from './app/core/services/keycloak-oidc-provider.service';
import { SessionGuardService } from './app/session-guard.service';
import { environment } from './environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { errorToastInterceptor } from './app/interceptors/error-toast.interceptor';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './app/core/window/directives/custom-overlay-container';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppInitializer } from './app/core/util/app-initializer';
import { KeycloakService } from './app/core/services/keycloak-service';
import { keycloakBearerInterceptor } from './app/interceptors/keycloak-bearer-interceptor';
import { dualTokenInterceptor } from './app/interceptors/dual-token-interceptor';
import { provideRouter } from '@angular/router';
import { provideNgxPendo } from 'ngx-pendo';
import { InitializationService } from './app/core/services/initialization.service';
import { idmLoggingInterceptor } from './app/interceptors/idm-logging-interceptor';
import { CustomHeaderConfigService } from './app/command-central/custom-header-config.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideStore(),
        {
            provide: HeaderConfigService,
            useClass: CustomHeaderConfigService
        },
        provideAppInitializer(() =>
            AppInitializer(
                inject(InitializationService),
                inject(EnvironmentService),
                inject(KeycloakService),
                inject(KeycloakOidcProviderService),
                inject(SessionGuardService),
                inject(HeaderConfigService)
            )
        ),
        environment.providers,
        provideServiceWorker('msi-service-worker.js', {
            registrationStrategy: 'registerImmediately'
        }),
        importProvidersFrom(BrowserModule, HotkeyModule.forRoot(), CommandCentralHeaderComponentsModule),
        provideNgxPendo({ pendoApiKey: '1d73cd03-4e84-49ff-6c48-0b7ba9a22359' }),
        { provide: OverlayContainer, useClass: CustomOverlayContainer },
        provideRouter(APP_ROUTES),
        provideAnimations(),
        provideHttpClient(withInterceptors([keycloakBearerInterceptor, dualTokenInterceptor, idmLoggingInterceptor, errorToastInterceptor]))
    ]
};
